import { NgModule } from '@angular/core';
import { MultiTagsComponent } from './multi-tags.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';



@NgModule({
  declarations: [
    MultiTagsComponent,
  ],

  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    ScrollingModule
  ],

  exports: [
    MultiTagsComponent
  ],

  providers: [ ],

})

export class MultiTagsModule { }
